import { connection } from "../../config";
import { httpUtil } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";
const querystring = require('querystring');

let urlPlugin = document._portalConfig.urlPlugin;
let apiKeyPlugin = document._portalConfig.apiKeyPlugin;
let urlPaygate = document._portalConfig.urlPaygate;
let apiKeyPaygate = document._portalConfig.apiKeyPaygate;
let newApiFlow = connection.newApiFlow;

export const lab4services = {
    getProducts,
    onCheckCoverage,
    makeOrderVumatel,
    onCheckEmailAddress,
    getOrderStatus,
    reOrderVumatel,
    createContactCRM,
    makeOrderCRM,
    updateOrderStatus,
    getChangeServices,
    onTerminateCRM,
    continuePayment,
    onEstimateServices,
    onChangeServiceVumatel,
    onChangeServiceCRM,
    onTerminateVumatel,
    onTerminateOpenserve,
    getDetailProduct,
    getServiceProduct,
    getTerminateReason,
    onUploadFile,
    onGetFiles,
    updateCampain,
    onGetOrderExpire,
    onReOrderExpire,
    onUpdateAddressContact,
    getOrderStatusV2,
    getVumatelReTryPaymentLink,
    getVumatelReNewPaymentLink,
    getVumatelUpdateCard,
    getProductsV3,
    initPayment,
    createPayment,
    onSubmitPayment,
    onDeleteContactCRM,
    getPaymentInfoV2,
    cancelOrderV2,
    registerContact,
    makeOrderV2VumaCore,
    checkLocationAvaibleOrderV3,
    makeOrderV2Openserve,
    getContactOutStandingAmount,
    onCheckCoverageLatLongV3,
    makeOrder,
    initTopup,
    createTopup,
    submitTopup,
    checkONTOfLines,
    verifyONTOfLines,
    onChangeServiceOpenserve,
    onCancelServiceOpenserve,
    makePreorder,
    onChangeServiceMetrofibre
}

//#region not sure used
async function getProducts() {
    try {
        let response = await get({
            resourcePath: "/registration/products",
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getProducts: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function makeOrderVumatel({
    contact_id,
    contact_code,
    product_id,
    first_name,
    last_name,
    phone_number,
    email,
    location_reference,
    product_reference,
    recurring_payment_date,
    is_recuring = false,
    identity_number,
    payment_redirect_url,
    product_type,
    make_payment_success,
}) {
    try {
        let response = await post({
            resourcePath: "/vumatel/make_order",
            body: {
                contact_id,
                contact_code,
                product_id,
                first_name,
                last_name,
                phone_number,
                email,
                location_reference,
                product_reference,
                recurring_payment_date,
                is_recuring,
                identity_number,
                payment_redirect_url,
                product_type,
                make_payment_success,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception makeOrderVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOrderStatus(contact_id, order_id, order_type) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/orders/order_status' : "/registration/order_status",
            queryParams: {
                contact_id: contact_id,
                order_id: order_id,
                order_type: order_type
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getProducts: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function reOrderVumatel({
    contact_id,
    product_id,
    first_name,
    last_name,
    phone_number,
    email,
    location_reference,
    product_reference,
    recurring_payment_date,
    is_recuring = false,
    identity_number,
    payment_redirect_url,
}) {
    try {
        let response = await post({
            resourcePath: "/vumatel/reorder",
            body: {
                contact_id,
                product_id,
                first_name,
                last_name,
                phone_number,
                email,
                location_reference,
                product_reference,
                recurring_payment_date,
                is_recuring,
                identity_number,
                payment_redirect_url,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception makeOrderVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function createContactCRM({
    first_name,
    last_name,
    passport_number,
    id_number,
    identity,
    phone_number,
    country_code,
    service_acceptance = true,
    email_opt_out = false,
    sms_opt_out = false,
    address,
    device_name,
}) {
    try {
        let response = await post({
            resourcePath: "/registration/create_contact",
            body: {
                first_name,
                last_name,
                passport_number,
                id_number,
                identity,
                phone_number,
                country_code,
                // service_acceptance,
                // email_opt_out,
                // sms_opt_out,
                address,
                device_name,
            }
        });
        if (response.code === "OK" && response.data && response.data.access_token) {
            httpUtil.startSession(response.data);//comment
            return createResult(ErrorCodes.OK, response.data);
        } else {
            if (response.error && (response.error.error === "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION" || response.error.error === "CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION")) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else if (response.error && response.error.error === "COM.CRM.EXCEPTIONS.INVALIDPASSWORDEXCEPTION") {
                return createResult(
                    ErrorCodes.INVALID_PASSWORD_EXCEPTION,
                    response.error
                );
            } else if (
                response.error &&
                response.error.error ===
                "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION"
            ) {
                return createResult(
                    "INVALID_CONTACTPASSWORD_EXCEPTION",
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
        //check return code here instead of put as there would be different intepretation for different API
        // return createCommonResult(response);
    } catch (e) {
        console.log("Exception createContactCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function makeOrderCRM({
    contact_id,
    product_id,
    product_type,
    order_amount,
}) {
    try {
        let response = await post({
            resourcePath: "/registration/make_order",
            body: {
                contact_id,
                product_id,
                product_type,
                order_amount,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception makeOrderCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onDeleteContactCRM(contact_id) {
    try {
        let response = await deleteMethod({
            resourcePath: "/registration/contacts/" + contact_id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onDeleteContactCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
//#endregion

//#region registration
async function getProductsV3() {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/registration/products' : "/registration/v3/products",
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getProductsV3: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onCheckCoverage({
    town_city,
    postal_code,
    street_name,
    street_number,
    latitude,
    longitude,
    location_reference = null,
    state_province_county,
}) {
    try {
        let response = await post({
            resourcePath: "/vumatel/check_coverage",
            body: {
                town_city,
                postal_code,
                street_name,
                street_number,
                latitude,
                longitude,
                location_reference,
                state_province_county,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onCheckCoverrage: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onCheckCoverageLatLongV3({
    latitude,
    longitude,
    location_reference = null,
    town_city,
    postal_code,
    street_name,
    street_number,
    state_province_county,
    suburb,
    uuid,
}) {
    try {
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/registration/check_coverage_lat_lon' : "/vumatel/v3/check_coverage_lat_lon",
            body: {
                latitude,
                longitude,
                location_reference,
                town_city,
                postal_code,
                street_name,
                street_number,
                state_province_county,
                suburb,
                uuid,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onCheckCoverageLatLongV3: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getDetailProduct(productCode, is_recurring = false) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? `/lab4/registration/products/${productCode}` : `/registration/products/${productCode}`,
            queryParams: {
                is_recurring: is_recurring
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getDetailProduct: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function checkONTOfLines({
    lat,
    lng,
    uuid,
}) {
    try {
        let response = await get({
            resourcePath: `/lab4/registration/check_ont_of_lines`,
            queryParams: {
                lat,
                lng,
                uuid,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception checkONTOfLines: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function verifyONTOfLines({
    lat,
    lng,
    uuid,
    ont
}) {
    try {
        let response = await get({
            resourcePath: `/lab4/registration/verify_ont_of_lines`,
            queryParams: {
                lat,
                lng,
                uuid,
                ont
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception verifyONTOfLines: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onCheckEmailAddress(email) {
    try {
        let response = await get({
            resourcePath: "/registration/email_validation",
            queryParams: {
                email_address: email
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onCheckEmailAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function checkLocationAvaibleOrderV3({
    locationId,
    openserve_ref_isp,
    lat,
    lng,
    uuid,
    metrofibre_ref_isp,
}) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/registration/check_location_available_order' : "/vumatel/v3/check_location_available_order",
            queryParams: {
                location_id: locationId,
                openserve_ref_isp: openserve_ref_isp,
                lat: lat,
                lng: lng,
                uuid,
                metrofibre_ref_isp,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception checkLocationAvaibleOrderV3: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

//#endregion

//#region service actions
async function getChangeServices(product_id) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/subscription/change_services' : "/subscription/change_services",
            queryParams: {
                product_id: product_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getChangeServices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onEstimateServices({
    from_service_id,
    to_service_id,
    action,
    to_price_terms_id,
    scheduled_date
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/subscription/estimate_change_services' : "/subscription/estimate_change_services",
            body: {
                contact_id: id,
                from_service_id,
                to_service_id,
                action,
                to_price_terms_id,
                scheduled_date
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onEstimateServices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onChangeServiceVumatel({
    from_service_id,
    to_service_id,
    current_product_id,
    action,
    from_service_code,
    to_service_code,
    recurring_payment_date,
    is_recuring,
    payment_redirect_url,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: "/vumatel/update_order",
            body: {
                contact_id: id,
                from_service_id,
                to_service_id,
                current_product_id,
                action,
                from_service_code,
                to_service_code,
                recurring_payment_date,
                is_recuring,
                payment_redirect_url,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onChangeServiceVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onChangeServiceMetrofibre({
    product_id,
    scheduled_date,
    price_terms_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: "/metrofibre/change_service",
            body: {
                contact_id: id,
                product_id,
                scheduled_date,
                price_terms_id,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onChangeServiceVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onChangeServiceOpenserve(body) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await put({
            resourcePath: "/openserve/services",
            body:body,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onChangeServiceVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onCancelServiceOpenserve(body) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await put({
            resourcePath: "/openserve/services/cancel",
            body:body,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onChangeServiceVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onChangeServiceCRM({
    from_service_id,
    to_service_id,
    action,
    is_recuring,
    recurring_payment_date,
    subscription_id,
    to_price_terms_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: "/subscription/change_services",
            body: {
                contact_id: id,
                from_service_id,
                to_service_id,
                action,
                is_recuring,
                recurring_payment_date,
                subscription_id,
                to_price_terms_id,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onChangeServiceCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onTerminateCRM(service_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/subscription' : "/subscription/terminate_service",
            body: {
                contact_id: id,
                service_id: service_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onTerminateCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onTerminateVumatel(service_id, reason_id, current_product_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/api/vumatel/terminate_service' : "/vumatel/terminate_service",
            body: {
                contact_id: id,
                service_id: service_id,
                reason: reason_id,
                current_product_id: current_product_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onTerminateVumatel: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onTerminateOpenserve(service_id, reason_id, current_product_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/api/openserve/terminate_service' : "/openserve/terminate_service",
            body: {
                contact_id: id,
                service_id: service_id,
                reason: reason_id,
                current_product_id: current_product_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onTerminateOpenserve: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getTerminateReason() {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/api/vumatel/terminate_reason' : "/vumatel/terminate_reason",
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getTerminateReason: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getServiceProduct(id) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? `/lab4/subscription/service/${id}` : "/subscription/service/" + id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getServiceProduct: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

//#endregion

//#region payment/topups
async function continuePayment({
    contact_id,
    product_type,
}) {
    try {
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/subscription/continue_payment' : "/subscription/continue_payment",
            body: {
                contact_id,
                product_type,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception continuePayment: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getVumatelReTryPaymentLink(id) {
    try {
        let response = await get({
            resourcePath: "/vumatel/retry_payment/" + id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getVumatelReTryPaymentLink: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getVumatelReNewPaymentLink(id) {
    try {
        let response = await get({
            resourcePath: "/vumatel/renew_payment_link/" + id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getVumatelReNewPaymentLink: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function initPayment({
    email_address,
    contact_code,
    contact_id,
    amount,
    organisation = 'lab4',
    type
    // payment_id,
} = {}) {
    try {
        const response = await post({
            resourcePath: '/payment_gateways/initiate_payment_tokenization',
            body: {
                contact_id: contact_id,
                email_address: email_address,
                contact_code: contact_code,
                amount: amount,
                // payment_id: payment_id,
                organisation: organisation,
                type: type
            },
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function createPayment({
    contact_id,
    payment_request_id,
    amount,
    life_cycle_state,
}) {
    try {
        let response = await post({
            resourcePath: "/payment_gateways/create_payment",
            body: {
                contact_id: contact_id,
                code: payment_request_id,
                amount: amount,
                life_cycle_state: life_cycle_state,
            },
            isPaygate: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception createPayment: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onSubmitPayment({
    payment_request_id,
    checksum,
    organisation = "lab4"
}) {
    try {
        let response = await post({
            resourcePath: "/payment_gateways/submit_payment",
            body: {
                payment_request_id: payment_request_id,
                checksum: checksum,
                organisation: organisation,
            },
            isPaygate: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onSubmitPayment: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPaymentInfoV2(contact_code) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/registration/payment_info' : "/registration/v2/payment_info",
            queryParams: {
                contact_code: contact_code,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getPaymentInfoV2: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function initTopup({
    email_address,
    contact_code,
    contact_id,
    amount,
    organisation = 'lab4',
    type,
    // payment_id,
} = {}) {
    try {
        const response = await post({
            resourcePath: '/payment_gateways/initiate_topup_tokenization',
            body: {
                contact_id: contact_id,
                email_address: email_address,
                contact_code: contact_code,
                amount: amount,
                // payment_id: payment_id,
                organisation: organisation,
                type: type,
            },
            isPaygate: true,
        });
        return response;
    } catch (ex) {
        return ex;
    }
}

async function createTopup({
    contact_id,
    payment_request_id,
    amount,
    life_cycle_state,
}) {
    try {
        let response = await post({
            resourcePath: "/payment_gateways/create_topup",
            body: {
                contact_id: contact_id,
                code: payment_request_id,
                amount: amount,
                life_cycle_state: life_cycle_state,
            },
            isPaygate: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception createTopup: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function submitTopup({
    payment_request_id,
    checksum,
    organisation = "lab4"
}) {
    try {
        let response = await post({
            resourcePath: "/payment_gateways/submit_topup",
            body: {
                payment_request_id: payment_request_id,
                checksum: checksum,
                organisation: organisation,
            },
            isPaygate: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onSubmitTopup: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
//#endregion

//#region topup
//#endregion

//#region orders
async function onGetOrderExpire() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await get({
            resourcePath: newApiFlow ? `/lab4/subscription/expire_order/preview/${id}` : `/subscription/expire_order/preview/${id}`,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onGetOrderExpire: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onReOrderExpire() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? `/vumatel/api/expire_order/reorder/${id}` : `/vumatel/expire_order/reorder/${id}`,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onReOrderExpire: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getOrderStatusV2({
    contact_id,
    order_id,
    order_type,
}) {
    try {
        let id = httpUtil.getSession() && httpUtil.getSession().sub ? httpUtil.getSession().sub : null;
        let response = await get({
            resourcePath: newApiFlow ? '/lab4/orders/v2/order_status' : "/registration/v2/order_status",
            queryParams: {
                contact_id: contact_id ? contact_id : id,
                order_id: order_id,
                order_type: order_type,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getProducts: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateOrderStatus({
    contact_id,
    order_id,
    result,
}) {
    try {
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/orders/update_order_status' : "/registration/update_order_status",
            body: {
                contact_id,
                order_id,
                result,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception makeOrderCRM: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function cancelOrderV2(payload) {
    try {
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/orders/cancel_order' : "/registration/v2/cancel_order",
            body: payload,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception cancelOrderV2: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function registerContact({
    product_id,
    location_reference,
    product_reference,
    recurring_payment_date,
    payment_redirect_url,
    is_recuring,
    product_type,
    order_amount,
    contact,
    utm_source,
    utm_campain,
    openserve_location_reference,
    contact_id,
    contact_code,
    referral_code,
    metrofibre_polygon_id,
    metrofibre_ref_isp
}) {
    try {
        let body = {
            product_id,
            location_reference,
            product_reference,
            recurring_payment_date,
            payment_redirect_url,
            is_recuring,
            product_type,
            order_amount,
            contact,
            utm_source,
            utm_campain,
            openserve_location_reference, 
            contact_id,
            contact_code,
            referral_code,
            metrofibre_ref_isp,
            metrofibre_polygon_id
        };
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/registration/contact' : "/registration/v2/make_order",
            body: body,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("registerContact exception: ", e);
        return createCommonResult(ErrorCodes.UNKNOWN, e);
    }
}

async function makeOrder(payload) {
    try {
        let response = await post({
            resourcePath: '/lab4/orders/make_order',
            body: payload,
        })
        return createCommonResult(response);
    } catch (ex) {
        console.log("AAAA makeOrder exception: ", ex)
        return createCommonResult(ErrorCodes.UNKNOWN, ex)
    }
}

async function makeOrderV2VumaCore(payload) {
    try {
        let response = await post({
            resourcePath: '/vumatel/v2/make_order_vumacore',
            body: payload,
        })
        return createCommonResult(response);
    } catch (ex) {
        console.log("AAAA makeOrderV2VumaCore exception: ", ex)
        return createCommonResult(ErrorCodes.UNKNOWN, ex)
    }
}

async function makeOrderV2Openserve(payload) {
    try {
        let response = await post({
            resourcePath: '/openserve/v2/make_order_openserve',
            body: payload,
        })
        return createCommonResult(response);
    } catch (ex) {
        console.log("AAAA makeOrderV2Openserve exception: ", ex)
        return createCommonResult(ErrorCodes.UNKNOWN, ex)
    }
}

async function makePreorder(payload) {
    try {
        let response = await post({
            resourcePath: '/lab4/orders/pre_order',
            body: payload,
        })
        return createCommonResult(response);
    } catch (ex) {
        console.log("AAAA makePreorder exception: ", ex)
        return createCommonResult(ErrorCodes.UNKNOWN, ex)
    }
}

//#endregion

//#region other functions
async function onUpdateAddressContact({
    address_line_1,
    address_line_2,
    state_province_county,
    town_city,
    postal_code,
    lat,
    lon,
    vumatel_premise_id,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? `/lab4/registration/contacts/${id}/update_address` : `/registration/contacts/${id}/update_address`,
            body: {
                address_line_1,
                address_line_2,
                state_province_county,
                town_city,
                postal_code,
                lat,
                lon,
                vumatel_premise_id,
            },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onUpdateAddressContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getVumatelUpdateCard(id) {
    try {
        let response = await get({
            resourcePath: "/vumatel/update_credit_card/" + id,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getVumatelUpdateCard: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function deleteMethod({
    resourcePath,
    body,
    isPaygate,
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'DELETE';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);

        console.log("DELETE uri:", uri);
        console.log("DELETE options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("DELETE exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function getContactOutStandingAmount(contactCode) {
    try {
        let response = await get({
            resourcePath: newApiFlow ? `/lab4/subscription/get_outstanding_amount?contact_code=${contactCode}` : `/subscription/get_outstanding_amount?contact_code=${contactCode}`,
        });
        
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getProductsV2: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onUploadFile(file_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/subscription/files' : "/subscription/files",
            body: {
                contact_id: id,
                file_id: file_id,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onUploadFile: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onGetFiles() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await get({
            resourcePath: "/subscription/files",
            queryParams: {
                contact_id: id
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception onUploadFile: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateCampain(utm_source, utm_campain) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await post({
            resourcePath: newApiFlow ? '/lab4/subscription/update_campain' : "/subscription/update_campain",
            body: {
                contact_id: id,
                utm_source: utm_source,
                utm_campain: utm_campain,
            }
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateCampain: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

//#endregion

//#region helpers
function createOption(isPaygate) {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'api_key': isPaygate ? apiKeyPaygate : apiKeyPlugin,
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath, isPaygate) {
    if (isPaygate) return urlPaygate + resourcePath;
    else return urlPlugin + resourcePath;
}

async function get({
    resourcePath,
    queryParams
}) {
    try {
        var options = createOption();
        options.method = 'GET';
        let uri = getURI(resourcePath);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        console.log("GET options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    isPaygate
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'POST';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);

        console.log("POST uri:", uri);
        console.log("POST options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
async function put({
    resourcePath,
    body,
    isPaygate
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'PUT';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);

        console.log("put uri:", uri);
        console.log("put options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("put exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
//#endregion
